export enum ColumnsEnum {
  ID = 'id',
  NAME = 'name',
  CREATED_DATE = 'created_date',
  ACTIONS = 'actions',
}
